import type { TChatSource } from '@homepal/api-contract'

import { Context } from 'types/GlobalUserEvents'

// The chat's attribution is a coarser projection of the entry-point context
// the dialog was opened with. `TChatSource` has three buckets; several
// contexts collapse into the same one.
const CHAT_SOURCE_BY_CONTEXT: Partial<Record<Context, TChatSource>> = {
  [Context.FROM_METRIC_PAGE]: 'metric_show_content',
  [Context.FROM_KEY_METRICS_PAGE]: 'metric_show_content',
  [Context.FROM_INSIGHT]: 'analysis_show_content',
  [Context.FROM_DASHBOARD_PAGE]: 'dashboard_show_content',
  [Context.FROM_REPORT_PAGE]: 'dashboard_show_content'
}

// Derive where the chat was started from. Falls back to the generic
// "show content" bucket for any entry point not explicitly mapped.
export const getChatSource = (context: Context): TChatSource =>
  CHAT_SOURCE_BY_CONTEXT[context] ?? 'dashboard_show_content'

// Only analysis chats list earlier chats.
export const hasChatHistory = (source: TChatSource): boolean =>
  source === 'analysis_show_content'
